<button
  *ngFor="let newPaymentMethodTypeOption of newPaymentMethodTypeOptions$ | async"
  class="d-flex align-items-center p-4"
  [class.new-payment-method-type-option--locked]="locked()"
  [class.new-payment-method-type-option--shake]="shakingType() === newPaymentMethodTypeOption.type"
  [attr.aria-disabled]="locked()"
  (click)="onPaymentOptionClick(newPaymentMethodTypeOption.type)"
  (animationend)="shakingType.set(null)"
  [attr.data-cy]="'new-payment-method-type-option-' + newPaymentMethodTypeOption.type"
>
  <img [src]="PAYMENT_METHOD_LOGO_DIRECTORY + newPaymentMethodTypeOption.icon + '.svg'" width="16" height="16" alt="" class="me-2">
  <p class="body-400">{{ newPaymentMethodTypeOption.name }}...</p>
  @if (locked()) {
    <aiwyn-icon name="lock" width="16" height="16" class="ms-auto new-payment-method-type-option__lock"></aiwyn-icon>
  }
</button>
